import React from 'react';
import { GongIntegration, SalesforceIntegration } from './components';
import { EnterpriseOnlyModal } from './components/EnterpriseOnlyModal';
import { HubspotIntegration } from './components/hubspot';
import { FathomIntegration } from './components/fathom/FathomIntegration';

export const TeamIntegrations: React.FC = () => {
  return (
    <div className="pb-14.5">
      <h1 className="text-display-sm font-display font-medium text-gray-900 md:hidden">
        Team integrations
      </h1>
      <div className="grid gap-8 grid-cols-3 xl:grid-cols-2 sm:grid-cols-1 mt-6">
        <GongIntegration />
        <SalesforceIntegration />
        <EnterpriseOnlyModal />
        <HubspotIntegration />
        <FathomIntegration />
      </div>
    </div>
  );
};
